<template>
	<div class="v-container">
		<div class="v-page-header">任务统计</div>
		<div class="v-filter">
			<div class="v-filter-row">
				<div class="v-filter-item v-filter-item-range">
					<el-date-picker style="width: 100%;" size="mini" v-model="time" value-format="yyyy-MM-dd" @change="
              (time) => {
                vForm.start_time = time[0];
                vForm.end_time = time[1];
              }
            " type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
				</div>
				<div class="v-filter-item" v-loading="regionLoading">
					<el-cascader v-model="region" @change="onRegionChange" placeholder="区域筛选" size="small" :props="{
              value: 'id',
              label: 'name',
              children: 'child',
              checkStrictly: true,
              expandTrigger: 'hover'
            }" :options="regionList" filterable style="width: 100%"></el-cascader>
				</div>
				<div class="v-filter-item">
					<el-select :disabled="tab == 'chart'" v-model="vForm.status" placeholder="任务状态筛选" size="small" style="width: 100%;">
						<el-option :value="0" label="未指派"></el-option>
						<el-option :value="1" label="处理中"></el-option>
						<el-option :value="2" label="处理完成"></el-option>
						<el-option :value="3" label="确认通过"></el-option>
					</el-select>
				</div>
				<div class="v-filter-item" v-loading="pointsTypeLoading">
					<el-select :disabled="tab == 'chart'" v-model="vForm.type" placeholder="任务类型筛选" size="small" style="width: 100%;">
						<el-option v-for="item in pointsTypeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
					</el-select>
				</div>
			</div>
			<div class="v-filter-row">
				<div class="v-filter-item" v-loading="areaUserLoading">
					<el-select :disabled="tab == 'chart'" v-model="vForm.user_id" placeholder="创建人筛选" size="small" style="width: 100%;">
						<el-option v-for="item in areaUserList" :key="item.id" :value="item.id" :label="item.nickname"></el-option>
					</el-select>
				</div>
				<div class="v-filter-item" v-loading="areaUserLoading">
					<el-select :disabled="tab == 'chart'" v-model="vForm.to_user_id" placeholder="处理人筛选" size="small" style="width: 100%;">
						<el-option v-for="item in areaUserList" :key="item.id" :value="item.id" :label="item.nickname"></el-option>
					</el-select>
				</div>
				<div class="v-filter-item">
					<el-select :disabled="tab == 'chart'" :value="worksName" placeholder="自然村筛选" size="small" style="width: 100%;"></el-select>
					<div class="select-works" @click="isShowWorks = true"></div>
				</div>
				<div class="v-filter-item">
					<el-select :disabled="tab == 'chart'" v-model="vForm.kind" placeholder="任务种类筛选" size="small" style="width: 100%;">
						<el-option :value="0" label="默认"></el-option>
						<el-option :value="1" label="新增"></el-option>
						<el-option :value="2" label="风险区"></el-option>
					</el-select>
				</div>
				<div class="v-filter-item">
					<el-button class="v-ml-5" type="primary" size="small" @click="doSearch(1)">搜索</el-button>
					<el-button class="v-ml-5" size="small" @click="reset()">重置</el-button>
				</div>
			</div>
		</div>
		<div class="v-total">
			<div class="v-total-item">
				<div class="label">未指派</div>
				<div class="num">{{ amount.init }}</div>
			</div>
			<div class="v-total-item">
				<div class="label">处理中</div>
				<div class="num">{{ amount.processing }}</div>
			</div>
			<div class="v-total-item">
				<div class="label">处理完成</div>
				<div class="num">{{ amount.processed }}</div>
			</div>
			<div class="v-total-item">
				<div class="label">确认通过</div>
				<div class="num">{{ amount.complete }}</div>
			</div>
			<div class="v-total-item">
				<div class="label">任务总计</div>
				<div class="num">{{ amount.all }}</div>
			</div>
		</div>
		<div class="v-content-filter">
			<div @click="downloadExcel" v-if="tab == 'list'" class="item">
				<i class="iconfont icon-excel"></i>
				<div class="label">Excel导出列表</div>
			</div>
			<div class="item" :class="{ active: tab == 'list' }" @click="
          tab = 'list';
          reset();
        ">
				<i class="iconfont icon-list"></i>
				<div class="label">列表</div>
			</div>
			<div class="item" :class="{ active: tab == 'chart' }" @click="
          reset();
          tab = 'chart';
        ">
				<i class="iconfont icon-chart"></i>
				<div class="label">图表</div>
			</div>
		</div>
		<div class="v-content" v-loading="loading">
			<el-table v-if="tab == 'list'" :data="lists" border size="small" style="width: 100%;">
				<el-table-column prop="title" label="任务名称" width="200" fixed />
				<el-table-column label="所属区域" width="150">
					<template slot-scope="scope">{{scope.row.areaName}}-{{scope.row.works_name}}</template>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间" width="150" />
				<el-table-column prop="type_name" label="任务类型" width="150" />
				<el-table-column label="任务状态" width="100">
					<template slot-scope="scope">
						<span :style="{color:polylineInfo[scope.row.status].color}">{{ polylineInfo[scope.row.status].text }}</span>
					</template>
				</el-table-column>
				<el-table-column label="任务种类" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.kind === 0">默认</span>
						<span v-if="scope.row.kind === 1">新增</span>
						<span v-if="scope.row.kind === 2">风险区</span>
					</template>
				</el-table-column>
				<el-table-column label="指派内容" width="150">
					<el-tooltip slot-scope="scope" :content="scope.row.content" placement="top-start">
						<div class="v-ellipsis">{{ scope.row.content }}</div>
					</el-tooltip>
				</el-table-column>
				<el-table-column prop="nickname" label="划线人" width="150" />
				<el-table-column prop="to_nickname" label="处理人" width="150" />
				<el-table-column label="操作" width="120" fixed="right">
					<template slot-scope="scope">
						<el-button @click="toView(scope.row)" type="default" size="min">查看</el-button>
						<el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
							<el-button :disabled="!scope.row.is_delete" slot="reference" size="min" class="v-ml-5" type="danger" :loading="scope.row.deleteLoading">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<e-chart v-if="tab == 'chart'" ref="vChart" :form="{
          start_time: vForm.start_time,
          end_time: vForm.end_time,
          region_street_id: vForm.region_street_id,
          area_id: vForm.area_id,
        }" />
		</div>
		<div v-if="tab == 'list'" class="v-footer">
			<el-pagination layout="total,sizes,prev, pager, next" @size-change="
          (page_size) => {
            getList(page, page_size);
          }
        " @current-change="
          (page) => {
            getList(page);
          }
        " :current-page.sync="page" :total="total"></el-pagination>
		</div>
		<works-list v-if="isShowWorks" :show.sync="isShowWorks" v-model="works" />
	</div>
</template>

<script>
	import eChart from './components/chart';
	import qs from 'qs';
	import worksList from './components/works-list';
	import polylineInfo from '@/pages/preview/polyline'

	export default {
		components: {eChart, worksList},

		data() {

			return {
				lists: [],
				polylineInfo,
				total: 0,
				loading: false,
				amount: {},
				time: [],
				region: [],
				regionList: [],
				regionLoading: false,
				pointsTypeList: [],
				pointsTypeLoading: [],
				tab: 'list',
				areaUserLoading: false,
				areaUserList: [],
				vForm: {
					start_time: '',
					end_time: '',
					to_user_id: '',
					user_id: '',
					status: '',
					type: '',
					region_street_id: '',
					area_id: '',
					works_id: '',
					kind:''
				},
				works: null,
				worksName: '',
				isShowWorks: false
			};
		},

		watch: {
			works: function (works) {
				if (works) {
					this.worksName = works.name;
					this.vForm.works_id = works.id;
				} else {
					this.worksName = this.vForm.works_id = '';
				}
			},
		},

		created() {
			this.getList();
			this.getRegionList();
			this.getPointsType();
			this.getAreaUsers();
		},


		methods: {
			//下载excel
			downloadExcel() {
				if (!this.vForm.start_time || !this.vForm.start_time) {
					this.$message.error('请选择要导出的日期区间')
					return
				}
				window.location = `${this.config.API_BASE}/api/basic/downloadTable?${qs.stringify(this.vForm)}&xx-token=${this.$store.getters.token}&client-type=${this.config.WEB}`;
			},

			//地域列表
			async getRegionList() {
				this.regionLoading = true;
				try {
					this.regionList = await this.$store.dispatch('user/getAreaList');
				} catch (e) {
					console.error(e);
				}
				this.regionLoading = false;
			},

			//获取任务类型数据
			async getPointsType() {
				this.pointsTypeLoading = true;
				try {
					let res = await this.api.setting.getPointsType();
					this.pointsTypeList = res.data;
				} catch (e) {
					console.error(e);
				}
				this.pointsTypeLoading = false;
			},

			//指派人处理人数据
			async getAreaUsers() {
				this.areaUserLoading = true;
				try {
					let res = await this.api.user.areaUsers({area_id: this.vForm.area_id || '',});
					this.areaUserList = res.data;
				} catch (e) {
					console.error(e);
				}
				this.areaUserLoading = false;
			},

			//搜索
			doSearch() {
				if (this.tab == 'list') {
					this.getList(1);
				}
				if (this.tab == 'chart') {
					this.getAnalyse();
				}
			},

			async getList(page, page_size) {
				this.loading = true;
				this.page = page ? page : this.page;
				this.page_size = page_size ? page_size : this.page_size;
				let vForm = Object.assign({}, this.vForm);
				vForm.status = vForm.status === '' ? -1 : vForm.status;
				vForm.kind = vForm.kind === '' ? -1 : vForm.kind;
				try {
					let res = await this.api.basic.index({
						page: this.page,
						page_size: this.page_size,
						...vForm,
					});
					this.lists = res.data.data;
					this.total = res.data.total;
					this.amount = res.data;
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			//任务状态
			getStatus(row) {
				return this.progress.filter((item) => item.value == row.status)[0];
			},

			getAnalyse() {
				this.$refs.vChart.getList();
			},

			onRegionChange(e) {
				this.vForm.area_id = e[e.length - 1];
				this.vForm.user_id = '';
				this.vForm.to_user_id = '';
				this.getAreaUsers();
			},

			reset() {
				for (let key in this.vForm) {
					this.vForm[key] = '';
				}
				this.vForm.start_time = '';
				this.vForm.end_time = '';
				this.vForm.works_id = '';
				this.vForm.kind = '';
				this.works = null;
				this.time = [];
				this.region = [];
				this.getAreaUsers();
				setTimeout(() => {
					if (this.tab == 'list') {
						this.getList(1);
					}
					if (this.tab == 'chart') {
						this.getAnalyse();
					}
				}, 0);
			},

			toView(c) {
				let routeResolve = this.$router.resolve({
					path: '/preview',
					query: {
						id: c.works_id,
						material_id: c.material_id,
						ath: c.points[1].ath,
						atv: c.points[1].atv
					}
				});
				window.open(routeResolve.href, '_blank');
			},

			async doDelete(row) {
				this.$set(row, 'deleteLoading', true);
				try {
					await this.api.polyline.delete({id: row.id});
					this.getList(1);
					this.$message.success('删除成功');
				} catch (e) {
					console.error(e);
				}
				this.$set(row, 'deleteLoading', false);
			},
		},
	};
</script>

<style scoped>
	.v-filter-row {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.v-filter-item {
		width: 200px;
		margin-right: 10px;
		position: relative;
	}

	.v-filter-item-range {
		width: 250px;
	}

	.v-total {
		display: flex;
		align-items: center;
		border-bottom: 1px solid #eee;
		padding-bottom: 30px;
		margin-bottom: 30px;
		padding-top: 60px;
	}

	.v-total-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 60px;
	}

	.v-total-item .label {
		font-size: 18px;
		margin-bottom: 10px;
	}

	.v-total-item .num {
		font-size: 18px;
	}

	.v-content-filter {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-bottom: 10px;
	}

	.v-content-filter .item {
		display: flex;
		align-items: center;
		margin-left: 20px;
		cursor: pointer;
	}

	.v-content-filter .item.active {
		color: #4e81ff;
		font-weight: bold;
	}

	.v-content-filter .item .label {
		margin-left: 5px;
	}

	.select-works {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		cursor: pointer;
	}
</style>
